module.exports = __webpack_public_path__ + "media/images/recruitment/bid-day-54942ac82f593de5c91082c1509294e6.jpg";